import { useParams } from 'react-router-dom';
import { Box, Text } from 'shared/Typhography';
import { FlexContainer } from 'shared/Typhography/flex-box';

import ColoringGridForm from './components/ColoringGridForm/ColoringGridForm';
import EditColoringGrid from './forms/EditColoringGrid/EditColoringGrid';

export const ManageColoringGridScreen = () => {
  const { id: paramId } = useParams<{ id?: string }>();
  const isCreate = !paramId;

  return (
    <FlexContainer
      margin={{ marginTop: '150px' }}
      dimensions={{ width: '100%' }}
      justifyContent="center"
    >
      <Box width="80%">
        <FlexContainer flexDirection="column" dimensions={{ width: '100%' }} gap="20px">
          <Text size={2} weight="bold">
            {isCreate ? 'Create new' : 'Update '} coloring grid
          </Text>
          {isCreate ? <ColoringGridForm /> : <EditColoringGrid />}
        </FlexContainer>
      </Box>
    </FlexContainer>
  );
};
